import styles from './styles.module.scss';

const LoadingSpinner = () => (
  <div className={styles.loading}>
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default LoadingSpinner;
